/**
 * Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {
    ClearReportOptionsPayload,
    ClearReportsPayload,
    FilterOptionsPayload,
    LaunchVideoPayload,
    LoadFeatureReportsPayload,
    SelectReportByNamePayload,
    SelectReportPayload,
    SetActiveFeatureReportsPayload,
    SetFeatureReportKeysPayload,
    SetParcelImageSizePayload,
    SetParcelDisplayAddressPayload,
    SetParcelPanoPayload,
    SetParcelImageUrlPayload,
    TableEditPayload,
    ResetReportPagesPayload,
    RequestVideoUrlPayload, ClearReportFiltersPayload
} from './report.model';
import { PagingOptionsPayload } from '../../../types/PagingOptions';

export class ClearReports {
    static readonly type = '[Reports] Clear reports';

    constructor(public payload?: ClearReportsPayload) {}
}

export class LoadDataReports {
    static readonly type = '[Reports] Load data reports';
}

export class SetActiveDataReports {
    static readonly type = '[Reports] Set active data reports';
}

export class LoadFeatureReports {
    static readonly type = '[Reports] Load feature reports';

    constructor(public payload: LoadFeatureReportsPayload) {}
}

export class SetActiveFeatureReports {
    static readonly type = '[Reports] Set active feature reports';

    constructor(public payload: SetActiveFeatureReportsPayload) {}
}

export class SetFeatureReportKeys {
    static readonly type = '[Reports] Set feature report keys';

    constructor(public payload: SetFeatureReportKeysPayload) {}
}

export class SelectReport {
    static readonly type = '[Reports] Select report';

    constructor(public payload: SelectReportPayload) {}
}

export class SelectFeatureReport {
    static readonly type = '[Reports] Select feature report';

    constructor(public payload: SelectReportPayload) {}
}

export class SelectDataReport {
    static readonly type = '[Reports] Select data report';

    constructor(public payload: SelectReportPayload) {}
}

export class SelectReportByName {
    static readonly type = '[Reports] Select report by name';

    constructor(public payload: SelectReportByNamePayload) {}
}

export class SelectFeatureReportByName {
    static readonly type = '[Reports] Select feature report by name';

    constructor(public payload: SelectReportByNamePayload) {}
}

export class SelectDataReportByName {
    static readonly type = '[Reports] Select data report by name';

    constructor(public payload: SelectReportByNamePayload) {}
}

export class RequestVideoUrl {
    static readonly type = '[Reports] Request Video Url';

    constructor(public payload: RequestVideoUrlPayload) {}
}

export class LaunchVideo {
    static readonly type = '[Reports] Launch Video';

    constructor(public payload: LaunchVideoPayload) {}
}

export class SetPagingOptions {
    static readonly type = '[Reports] Set paging options';

    constructor(public payload: PagingOptionsPayload) {}
}

export class ResetReportPagingAndSort {
    static readonly type = '[Reports] Reset current page(s)';

    constructor(public payload: ResetReportPagesPayload) {}
}

export class SetFilterOptions {
    static readonly type = '[Reports] Set report filters';

    constructor(public payload: FilterOptionsPayload) {}
}

export class ClearReportFilters {
    static readonly type = '[Reports] Clear Filters';

    constructor(public payload: ClearReportFiltersPayload) {}
}

export class ClearReportOptions {
    static readonly type = '[Reports] Clear report options';

    constructor(public payload: ClearReportOptionsPayload) {}
}

export class EnableTableEdit {
    static readonly type = '[Reports] Enable table edit';

    constructor(public payload: TableEditPayload) {}
}

export class DisableTableEdit {
    static readonly type = '[Reports] Disable table edit';

    constructor(public payload: TableEditPayload) {}
}

export class SetParcelImageUrl {
    static readonly type = '[Reports] Set parcel image url';

    constructor(public payload: SetParcelImageUrlPayload) {}
}

export class SetParcelPano {
    static readonly type = '[Reports] Set parcel pano id';

    constructor(public payload: SetParcelPanoPayload) {}
}

export class SetParcelDisplayAddress {
    static readonly type = '[Reports] Set parcel display address';

    constructor(public payload: SetParcelDisplayAddressPayload) {}
}

export class SetParcelImageSize {
    static readonly type = '[Reports] Set parcel report image size';

    constructor(public payload: SetParcelImageSizePayload) {}
}

export class ClearParcelDisplayOptions {
    static readonly type = '[Reports] Clear street view data';

    constructor(public payload: { id: string; reportName: string }) {}
}

export class RefreshFilterFields {
    static readonly type = '[Reports] Update filter dropdowns';
}

